












import {Component, Prop, Vue, Model, Emit} from 'vue-property-decorator';

@Component({
    name: 'MyRadio',
    mounted() {
    }
})
export default class MyRadio extends Vue {
    @Prop() label: string;
    @Prop() val: any;
    @Prop({
        default: false
    }) disabled: boolean;
    @Model('change', {})
    propValue: any;

    get isGroup(): boolean {                                                 // 是否在组里
        return this.$parent.$options['_componentTag'] === 'MyRadioGroup';
    }

    get isDisabled(): boolean {
        return this.$parent.disabled || this.disabled;
    }

    get selfValue(): string {
        return this.isGroup ? this.$parent.propValueArr : this.propValue;
    }

    set selfValue(newValue) {
        this.isGroup ? this.$parent.emitChange(newValue) : this.emitChange(newValue);
    }

    handleClick() {
        !this.isDisabled && (this.selfValue = this.val);
    }

    @Emit('change')
    emitChange(newValue: any): void {

    }
}
